import { render } from "./ProviderEditImage.vue?vue&type=template&id=26edddf6"
import script from "./ProviderEditImage.vue?vue&type=script&lang=js"
export * from "./ProviderEditImage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__